import { useEffect, useRef, useState } from 'react';
import { Icon } from '../components/ui/Icon';
import { useAuth } from '../auth/useAuth';

const CAMPAIGN_LOGO_URL =
  'https://bennett2026.org.il/wp-content/uploads/2026/05/Group-174675.svg';

export function TopBar() {
  const [logoOk, setLogoOk] = useState(true);
  return (
    <header className="topbar-p">
      <a className="tp-logo" href="#" onClick={(e) => e.preventDefault()}>
        {logoOk ? (
          <img
            src={CAMPAIGN_LOGO_URL}
            alt="ביחד בראשות בנט"
            onError={() => setLogoOk(false)}
          />
        ) : (
          <>
            <span className="tp-fallback">ב</span>
            <div>
              <span className="tp-wordmark" style={{ display: 'block' }}>ביחד</span>
              <div className="tp-sub">בראשות בנט</div>
            </div>
          </>
        )}
      </a>

      <span className="tp-divider" />

      <div className="tp-edition">
        <div className="ed-date">יום ראשון, 25 במאי 2026</div>
        <div className="ed-meta">
          <span>ח׳ בסיון תשפ״ו</span>
          <span className="ed-sep">·</span>
          <span><b>—</b> ימים לבחירות</span>
        </div>
      </div>

      <span className="tp-spacer" />

      <div className="tp-actions">
        <UserMenu />
      </div>
    </header>
  );
}

/**
 * User chip + dropdown. Shows the signed-in email (or a fallback initial), and
 * exposes a "התנתק" (sign-out) action that calls the auth provider's
 * `signOut()` — which in cognito-mode triggers a Hosted-UI logout redirect.
 */
function UserMenu() {
  const { claims, signOut } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  const label = claims?.email ?? 'משתמש';
  const initial = (claims?.email ?? 'א').trim().charAt(0).toUpperCase();

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="tp-avatar"
        onClick={() => setOpen((o) => !o)}
        title={label}
        style={{ cursor: 'pointer', border: 0 }}
      >
        {initial}
      </button>
      {open && (
        <div
          role="menu"
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            insetInlineEnd: 0,
            background: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: 8,
            boxShadow: '0 10px 24px rgba(15, 23, 42, 0.12)',
            minWidth: 200,
            zIndex: 50,
            overflow: 'hidden',
            fontFamily: 'Heebo, sans-serif',
          }}
        >
          <div style={{ padding: '10px 14px', borderBottom: '1px solid #f1f5f9' }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#0f172a' }}>
              {label}
            </div>
            {claims?.role && (
              <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>
                {claims.role}
              </div>
            )}
          </div>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              signOut();
            }}
            style={{
              display: 'block',
              width: '100%',
              padding: '10px 14px',
              textAlign: 'right',
              background: 'transparent',
              border: 0,
              cursor: 'pointer',
              fontSize: 13,
              color: '#0f172a',
            }}
          >
            התנתק
          </button>
        </div>
      )}
    </div>
  );
}
